class PeerService{ 
    constructor() {
        if (!this.peer) {
          this.peer = new RTCPeerConnection({
            iceServers: [
              {
                urls: [
                  "stun:stun.l.google.com:19302",
                  "stun:global.stun.twilio.com:3478",
                ],
              },
            ],
          });
        }
      }
      async getOffer(){ 
        if(this.peer){ 
            const offer = await this.peer.createOffer();
            await this.peer.setLocalDescription(new RTCSessionDescription(offer));
            return offer 
        }
      }
      async addTracks(myStream)
      {
        
        console.log("myStream:",myStream)
        for(const track of myStream.getTracks())
        { 
            this.peer.addTrack(track, myStream);
        }
      }

      async getAnswer(offer){
        if(this.peer)
        {
          await this.peer.setRemoteDescription(offer);
          const ans = await this.peer.createAnswer();
           await this.peer.setLocalDescription(new RTCSessionDescription(ans));
           return ans;
        }
      }
      async setLocalDescription(ans) {

        console.log("are asnwer prin t",ans);
        if (this.peer) {
          try {
            console.log("setting answer this dside")
            await this.peer.setRemoteDescription(new RTCSessionDescription(ans));
          } catch (error) {
           console.log(error);
          }
        }
      }
    
}


  
export default new PeerService();